import styled from "@emotion/styled";
import { UiTheme } from "@nykaa/payment-ui/src/@types";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";

export const NewCardPciContainer = styled.iframe`
  border: none;
  width: 100%;
  height: ${({ height }: UiTheme) => (height ? height : "220px;")};
`;

export const SavedCardPciContainer = styled.iframe`
  border: none;
  width: 100%;
  height: ${({ height }: UiTheme) => (height ? height : "220px;")};
`;

export const OtpPciContainer = styled.iframe`
  border: none;
  width: 100%;
  height: 90vh;
  display: block;
`;

export const RedirectContainer = styled.div``;

export const OtpPciDesktopLayout = styled.div`
  display: flex;
  box-sizing: border-box;
  background-color: ${({ theme }: UiTheme) => theme?.colors?.snow100};
  border-radius: 16px;
  flex-direction: column;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 424px;
  height: 518px;
  p:first-of-type {
    margin-bottom: 8px;
  }
`;

export const NewCardLayout = styled.div`
  display: flex;
  flex-direction: column;
  &.desktopLaypout {
  }
`;
// noMargin -- bottom-margin is not required in collapsed mode
export const NewCardLayoutMsite: any = styled.div`
  // display: ${({ isVisible }: UiTheme) => (isVisible ? "block" : "none")};
  visibility:  ${({ isVisible }: UiTheme) => (isVisible ? "visible" : "hidden")};
  opacity:  ${({ isVisible }: UiTheme) => (isVisible ? "1" : "0")};
  height: auto;
  background-color: ${({ theme }: UiTheme) => theme.colors.white};
  margin-bottom: ${({ noMargin }: UiTheme) => (noMargin ? "0px" : "16px")};
  overflow: hidden;
  max-height: ${({ isVisible }: UiTheme) => (isVisible ? "2000px" : "0")};
  ${({ leftPadding }: UiTheme) => (leftPadding ? "padding-left: 12px" : "padding-left: 0px")};

  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
  transition-property: all;  

`;

export const ExpressSavedPciContainer = styled.iframe`
  border: none;
  width: 100%;
  height: ${({ height }: UiTheme) => (height ? height : "220px;")};
`;

export const NewCardOfferMessageLayout: any = styled.div`
  margin: 8px 12px;
`;
export const ShimmerCardLayout = styled.div`
  margin: 10px 0px;
  position: relative;
  background-color: ${({ theme }: UiTheme) => theme?.colors?.white};
  ${({ theme }: UiTheme) => theme?.borders?.border100};
  border-color: ${({ theme }: UiTheme) => getHexToRgba(theme?.colors?.chipColor, 0.08)};
  border-radius: ${({ theme }: UiTheme) => theme?.borders?.radius30};
  padding: 10px;
`;

export const CardsPaymentOfferWrapper = styled.div`
  .offerLayoutWrapper {
    margin: 0 0 12px;
    height: 72px;
  }
  .offerCard {
    padding: 0 10px;
    div{
      margin-top: 0;
    }
  }
`;
